import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiHome, FiMapPin, FiPackage, FiKey, FiUser, FiLogOut, FiMic } from 'react-icons/fi';
import './Navbar.css';

const Navbar = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  if (!isAuthenticated) return null;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <span className="brand-icon">🚀</span>
          <span className="brand-text">DeliveryBridge</span>
        </Link>

        <div className="navbar-menu">
          <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>
            <FiHome />
            <span>Home</span>
          </Link>
          <Link to="/locations" className={`nav-link ${isActive('/locations') ? 'active' : ''}`}>
            <FiMapPin />
            <span>Locations</span>
          </Link>
          <Link to="/orders" className={`nav-link ${isActive('/orders') ? 'active' : ''}`}>
            <FiPackage />
            <span>Orders</span>
          </Link>
          <Link to="/gatepasses" className={`nav-link ${isActive('/gatepasses') ? 'active' : ''}`}>
            <FiKey />
            <span>Passes</span>
          </Link>
          <Link to="/delivery-instructions" className={`nav-link ${isActive('/delivery-instructions') ? 'active' : ''}`}>
            <FiMic />
            <span>Instructions</span>
          </Link>
          <Link to="/profile" className={`nav-link ${isActive('/profile') ? 'active' : ''}`}>
            <FiUser />
            <span>Profile</span>
          </Link>
        </div>

        <div className="navbar-user">
          <span className="user-name">{user?.name || user?.phone}</span>
          <button onClick={handleLogout} className="logout-btn">
            <FiLogOut />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
